module.exports = __webpack_public_path__ + "img/img-service-05@2x.2b1422d0.jpg";